import { AccountProductEnum, CardTypeEnum } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import theme from 'shared/styles/theme';

interface ManageCardListItemProps {
  title: string;
  cardId?: string;
  cardType?: CardTypeEnum;
  accountType?: string;
}

const ManageCardListItem = ({
  title,
  cardId,
  cardType,
  accountType,
}: ManageCardListItemProps) => {
  const router = useRouter();
  const gotoCardService = (cardId?: string) => {
    if (!cardId) {
      router.push({
        pathname: '/myvaro/card',
      });
    } else {
      router.push({
        pathname: '/myvaro/card/[cardId]',
        params: { cardId: cardId },
      });
    }
  };

  return (
    <>
      <ListItem
        primaryCopy={title}
        analyticsId={
          accountType === AccountProductEnum.ChargeCard
            ? 'believeManageCardClick'
            : 'manageCardClick'
        }
        customAttributes={
          accountType === AccountProductEnum.ChargeCard
            ? {
                card_type: cardType?.toLowerCase(),
                account_type: AccountProductEnum.ChargeCard.toLowerCase(),
                cta: 'Manage card',
              }
            : { card_type: cardType }
        }
        onPress={() => {
          gotoCardService(cardId);
        }}
      />
      <View style={styles.dividerWrapper}>
        <HairLineDivider />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  dividerWrapper: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
  },
});

export default ManageCardListItem;
